<template>
    <div class="Entry" id="entry">

        <!-- <div class="container-fluid blue-wave-top"></div> -->
        <div class="container-fluid blueback">
            <div class="container align-middle">
                <div class="row" v-if="!entryCreated">
                    <div class="col-12">
                        <h2>{{ $t('entry_title') }}</h2>

                        <p>{{ $t('entry_subtitle') }}</p>
                    </div>
                </div>

                <div class="row" v-if="error">
                    <div class="col-12">
                        <base-alert type="danger">{{error}}</base-alert>
                    </div>
                </div>

                <div class="row" v-if="entryCreated">
                    <div class="col-12">
                        <base-alert type="success" dismissible>
                            {{ $t('entry_created_message') }}
                        </base-alert>
                    </div>
                </div>

                <div class="row" v-if="!entryCreated">
                    <div class="col-12 col-sm-4">
                        <base-input v-model="name"
                                    :error="fieldError('name')" size="30" maxlength="255" :placeholder="`${$t('your_name')}*`"
                                    class="entry" type="text" required/>
                    </div>
                    <div class="col-sm-4">
                        <base-input v-model="email"
                                    :error="fieldError('email')" size="30" maxlength="255" :placeholder="`${$t('email')}*`"
                                    class="entry" type="text" required/>
                    </div>
                    <div class="col-sm-4">
                        <base-input v-model="phone"
                                    :error="fieldError('phone')" size="30" maxlength="255" :placeholder="`${$t('phone')}*`"
                                    class="entry" type="text"/>
                    </div>
                </div>
                <div class="row" v-if="!entryCreated">
                    <div class="col-12">
                        <textarea v-model="comment" rows="3" cols="50" :placeholder="$t('your_question')"
                                  class="entry-textarea"></textarea>
                    </div>
                </div>
                <div class="row" v-if="!entryCreated">
                    <div class="col-12">
                        <div class="personal" v-if="flavorConfig.personalDataNotice">* {{ $t('by_press_send_button') }}, {{ $t('personal_data_agree') }}
                        </div>
                        <input type="button" name="yt1" :value="$t('send')" class="otpravit" @click="submit"
                               :disabled="loading">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import timetablesApi from "../data/TimetablesApi";

    export default {
        name: "Entry",
        data() {
            return {
                name: null,
                email: null,
                phone: null,
                comment: null,
                buttonName: 'Показать расписание',

                entryCreated: false,

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },

        metaInfo() {
            return {
                // title: 'Обратный звонок',
                /*meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: '☝☝☝☝☝ Не можете определиться с курсом или остались вопросы? Закажите обратный звонок нашего специалиста!'
                    }
                ]*/
            }
        },
        mounted() {

        },

        methods: {
            submit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                let clientId = null
                if (this.$metrika && this.$metrika.getClientID()) clientId = this.$metrika.getClientID()
                timetablesApi.createEntry(this.name, this.phone, this.email, this.comment, clientId, window.location.href)
                    .then(response => {
                        this.loading = false
                        this.entryCreated = response
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('error_401')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },


            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css">
</style>


<style scoped>

    .alert {
        font-size: 18px;
        font-family: "Manrope Bold";
    }

    body {
        font-family: Manrope Light;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #000000;
        text-align: left;
    }

    p {
        color: #000000;
        font-weight: 400;
        line-height: 1.5;
    }

    .Entry {
        background-color: white !important;
    }

    .has-success::after, .has-danger::after {
        right: 28px;
        top: 7px;
    }

</style>
